import React, { Component } from 'react'
import LoanProperty2ListUI from './LoanProperty2ListUI.js'

class LoanProperty2ListSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      updateMode: false,
      multiUpdateMode: false,
      selectedProperty: null,
      selectedPropertyGroup: null,
    }
  }

  render() {
    let filteredList = this.props.propertyList ? this.props.propertyList.filter(p => p.category === this.props.category) : []
    return (
      <LoanProperty2ListUI
        context={this.props.context}
        errorList={this.props.errorList}
        loan={this.props.loan}
        propertyList={filteredList}
        selectedProperty={this.state.selectedProperty}
        selectedPropertyGroup={this.state.selectedPropertyGroup}
        updateMode={this.state.updateMode}
        multiUpdateMode={this.state.multiUpdateMode}
        categoryLabel={this.props.categoryLabel}
        onRefreshClick={this.props.onRefreshClick}
        onUpdateClick={this.onUpdateClick}
        onCancelClick={this.onCancelClick}
        onMultiCancelClick={this.onMultiCancelClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
  }

  onUpdateClick = (event) => {
    let propertyCode = event.currentTarget.getAttribute('data-property')
    console.log(propertyCode);
    let selectedProperty = this.props.propertyList.filter(p => p.propertyCode === propertyCode)[0]

    if (propertyCode === 'ev_parking_premise') {
      this.setState({
        multiUpdateMode: true,
        updateMode: false,
        selectedProperty: selectedProperty,
        selectedPropertyGroup: {
          titleLabel: selectedProperty.propertyName,
          rowLabel: 'Location',
          addLabel: '+ Add location',
          emptyError: 'Add at least one parking location',
          propertyCode: 'ev_parking_premise',
          fieldList: [
            { key: 'address', label: 'Parking address', maxLength: 500 },
            { key: 'owner', label: 'Owner of the parking premise', maxLength: 200 },
            { key: 'lessor', label: 'Lessor of the parking premise', maxLength: 200 },
          ],
        },
      })
      return
    }

    this.setState({
      updateMode: true,
      multiUpdateMode: false,
      selectedProperty: selectedProperty,
      selectedPropertyGroup: null,
    })
  }

  onCancelClick = () => {
    this.setState({ updateMode: false, errorList: null })
  }

  onMultiCancelClick = () => {
    this.setState({ multiUpdateMode: false, selectedPropertyGroup: null, errorList: null })
  }

}

export default LoanProperty2ListSF
